import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=371ffede&scoped=true&"
import script from "./MessageDialog.vue?vue&type=script&lang=js&"
export * from "./MessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MessageDialog.vue?vue&type=style&index=1&id=371ffede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ffede",
  null
  
)

export default component.exports